import { Component } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { AsReportedInsider } from "src/api/models";

@Component({
  selector: "app-view-insider-data",
  // imports: [],
  templateUrl: "./view-insider-data.component.html",
  styleUrl: "./view-insider-data.component.css",
  standalone: false,
})
export class ViewInsiderDataComponent {
  formData: any = {
    affiliateId: "",
    affiliateName: "",
    cik: "",
  };
  insiderData: AsReportedInsider[] = [];
  noRecord: boolean = false;
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    this.insiderData = this.config.data?.insiderData || [];
    this.noRecord = this.config.data?.noRecord || false;
  }

  onCancel() {
    this.ref.close();
  }
  onRevertInsider(insider: any) {
    this.ref.close({ revertInsider: insider });
  }
}
